import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from '../../shared/services';

@Component({
  selector: 'app-fundraiser-slider-img',
  templateUrl: './fundraiser-slider-img.component.html',
  styleUrls: ['./fundraiser-slider-img.component.scss']
})
export class FundraiserSliderImgComponent implements OnInit {

  @Input() gallery;
  @Input() isFOS;
  @Input() hasThumbs;
  @Input() slideType;
  @Input() basicInfo;
  @Input() shadow;
  isMobile;
  currentIndex = 0;
  focus = 0;
  autoSlide;

  constructor(
    public util: UtilService,
    public domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util.isMobile();
    this.autoSlide = this.gallery?.length > 1 ? true : false;
  }

  addYoutubeEmbed(slide) {
    const id = this.util.getYouTubeId(slide.path);
    slide.videoSrc = this.domSanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
    slide.showVideo = true;
  }

  thumbsOnClick(i) {
    this.autoSlide = false;
    this.focus = i;
    this.currentIndex = i;
  }

  getIndex(e) {
    if (e.direction === '>') {
      this.currentIndex++;
    } else if (e.direction === '<') {
      this.currentIndex--;
    }
    if (this.currentIndex >= this.gallery?.length) {
      this.currentIndex = 0;
    } else if (this.currentIndex < 0) {
      this.currentIndex = this.gallery?.length - 1;
    }
  }

}
